export default __webpack_public_path__ + "files/bd3035b63982f35cfebfd5f010a34e79.jpg";